import React from 'react';

export const ErrorContext = React.createContext(undefined);

interface ErrorDisplayProviderProps {
    error: boolean;
}

interface ErrorContextShape extends ErrorDisplayProviderProps {
    setError: (error: boolean) => void;
}

export const ErrorDisplayContext = React.createContext<
    Partial<ErrorContextShape>
>({});

export const useErrorDisplayContext = () => {
    const value = React.useContext(ErrorDisplayContext);

    if (value === undefined) {
        throw new Error(
            'useErrorDisplayContext must be used within ErrorDisplayProvider',
        );
    }

    return value;
};

export const ErrorDisplayProvider: React.FC<React.PropsWithChildren<ErrorDisplayProviderProps>> = ({ children, error: initialError }) => {
    const [error, setError] = React.useState(initialError);

    return (
        <ErrorDisplayContext.Provider
            value={{
                error,
                setError,
            }}
        >
            {children}
        </ErrorDisplayContext.Provider>
    );
};
